import { Injectable } from "@angular/core";

@Injectable({ providedIn: "root" })
export class BrowserStorageService {
  private readonly storage: Storage | null =
    typeof window !== "undefined" ? window.localStorage : null;

  getItem(key: string): string | null {
    return this.storage?.getItem(key) ?? null;
  }

  setItem(key: string, value: string): void {
    this.storage?.setItem(key, value);
  }

  removeItem(key: string): void {
    this.storage?.removeItem(key);
  }
}
